import $ from 'jquery';

/**
 * @desc Social media sharing component
 */
export default class SocialMediaSharing {
  constructor() {
    this.$mediaEntity = $('.js-news-article');
    this.mediaLink = this.$mediaEntity.data('link');
    this.mediaTitle = this.$mediaEntity.data('title');

    this.$sharePopup = $('.js-mobile-share-popup');
    this.$showPopUpButton = $('.js-show-available-networks');
    this.$hidePopUpButton = $('.js-close-social-sharing');

    this.$smsButton = $('.js-share-via-sms');
    this.$whatsappButton = $('.js-share-via-whatsapp');
    this.$twitterButton = $('.js-share-via-twitter');
    this.$facebookButton = $('.js-share-via-facebook');
    this.$emailButton = $('.js-share-via-email');

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$smsButton.length
        && !this.$whatsappButton.length
        && !this.$emailButton.length
        && !this.$twitterButton.length
        && !this.$facebookButton.length
        && !this.$showPopUpButton.length
        && !this.$hidePopUpButton.length
        && !this.$sharePopup.length
    ) {
      this.isInitialized = false;

      return;
    }

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.$smsButton.click(() => this.shareViaSms());
    this.$whatsappButton.click(() => this.shareViaWhatsapp());
    this.$emailButton.click(() => this.shareViaMail());
    this.$twitterButton.click(() => this.shareViaTwitter());
    this.$facebookButton.click(() => this.shareViaFacebook());

    this.$showPopUpButton.click((event) => {
      $(event.currentTarget).addClass('is-outlineless');

      this.$sharePopup.addClass('is-shown');
      $(event.currentTarget).blur();
    });

    this.$hidePopUpButton.click(() => {
      this.$showPopUpButton.removeClass('is-outlineless');
      this.$sharePopup.removeClass('is-shown');
    });
  }

  /**
   * @param {string} url
   * @param {boolean} isOpenPopUp
   */
  static share(url, isOpenPopUp = false) {
    let params = '';

    if (isOpenPopUp) {
      const popUpWidth = 600;
      const popUpHeight = 480;

      const topCoordinate = window.innerHeight / 2 - popUpWidth / 2 + window.screenY;
      const leftCoordinate = window.innerWidth / 2 - popUpHeight / 2 + window.screenX;

      params = `
        scrollbars=no,
        width=${popUpWidth},
        height=${popUpHeight},
        top=${topCoordinate},
        left=${leftCoordinate}
      `;
    }

    window.open(url, '', params);
  }

  shareViaSms() {
    /**
     * @example without contact number - sms:?&body=message
     * @example with contact number - sms:1234567890;?&body=message
     */
    SocialMediaSharing.share(`sms:?&body=${encodeURIComponent(this.mediaLink)}`);
  }

  shareViaWhatsapp() {
    SocialMediaSharing.share(`whatsapp://send?text=${encodeURIComponent(this.mediaLink)}`);
  }

  shareViaMail() {
    SocialMediaSharing.share(`mailto:?body=${this.mediaTitle}${encodeURIComponent('\n\n')}${this.mediaLink}`);
  }

  shareViaTwitter() {
    SocialMediaSharing.share(
      // eslint-disable-next-line max-len
      `https://twitter.com/intent/tweet?text=${this.mediaTitle}${encodeURIComponent('\n')}${encodeURIComponent(this.mediaLink)}`,
      true,
    );
  }

  shareViaFacebook() {
    SocialMediaSharing.share(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.mediaLink)}`,
      true,
    );
  }
}
